module.exports = __webpack_public_path__ + "img/Produtos01.fw.65582c52.png";